import React from 'react';
import { FooterWrapper, FooterText } from './styled-components/Footer';

export default function Footer() {
    return(
        <FooterWrapper>
            <FooterText>Southwest Chiropractic, West Jordan, UT</FooterText>
            <FooterText>Phone: 801-254-9400</FooterText>
            <FooterText>Address: 8777 S Redwood Rd Suite 250, West Jordan, UT 84088</FooterText>
        </FooterWrapper>
    )
}